module.exports = __webpack_public_path__ + "static/media/order_icon4.05dc8e96.png";